/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ row: NonNullable<unknown> }} Knp_Terms_Csv_Row_Missing_TermInputs */

const en_knp_terms_csv_row_missing_term = /** @type {(inputs: Knp_Terms_Csv_Row_Missing_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Row ${i?.row}: Missing term`)
};

const fr_knp_terms_csv_row_missing_term = /** @type {(inputs: Knp_Terms_Csv_Row_Missing_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Ligne ${i?.row} : terme manquant`)
};

const de_knp_terms_csv_row_missing_term = /** @type {(inputs: Knp_Terms_Csv_Row_Missing_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Zeile ${i?.row}: Fehlender Term`)
};

const it_knp_terms_csv_row_missing_term = /** @type {(inputs: Knp_Terms_Csv_Row_Missing_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Riga ${i?.row}: Termine mancante`)
};

const ru_knp_terms_csv_row_missing_term = /** @type {(inputs: Knp_Terms_Csv_Row_Missing_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Строка ${i?.row}: Отсутствует термин`)
};

const es_knp_terms_csv_row_missing_term = /** @type {(inputs: Knp_Terms_Csv_Row_Missing_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Fila ${i?.row}: Término faltante`)
};

const zh_cn2_knp_terms_csv_row_missing_term = /** @type {(inputs: Knp_Terms_Csv_Row_Missing_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`行 ${i?.row}：缺少项`)
};

const ja_knp_terms_csv_row_missing_term = /** @type {(inputs: Knp_Terms_Csv_Row_Missing_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`行 ${i?.row}: 用語が見つかりません`)
};

const hi_knp_terms_csv_row_missing_term = /** @type {(inputs: Knp_Terms_Csv_Row_Missing_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`पंक्ति ${i?.row}: पद अनुपलब्ध है`)
};

const pt_pt2_knp_terms_csv_row_missing_term = /** @type {(inputs: Knp_Terms_Csv_Row_Missing_TermInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Linha ${i?.row}: Termo ausente`)
};

/**
* | output |
* | --- |
* | "Row {row}: Missing term" |
*
* @param {Knp_Terms_Csv_Row_Missing_TermInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const knp_terms_csv_row_missing_term = /** @type {((inputs: Knp_Terms_Csv_Row_Missing_TermInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Knp_Terms_Csv_Row_Missing_TermInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_knp_terms_csv_row_missing_term(inputs)
	if (locale === "de") return de_knp_terms_csv_row_missing_term(inputs)
	if (locale === "it") return it_knp_terms_csv_row_missing_term(inputs)
	if (locale === "ru") return ru_knp_terms_csv_row_missing_term(inputs)
	if (locale === "es") return es_knp_terms_csv_row_missing_term(inputs)
	if (locale === "zh-CN") return zh_cn2_knp_terms_csv_row_missing_term(inputs)
	if (locale === "ja") return ja_knp_terms_csv_row_missing_term(inputs)
	if (locale === "hi") return hi_knp_terms_csv_row_missing_term(inputs)
	if (locale === "pt-PT") return pt_pt2_knp_terms_csv_row_missing_term(inputs)
	return en_knp_terms_csv_row_missing_term(inputs)
});